import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/falta';
import Falta from './Falta';


const ms2p = (state) => {
  return {
    ...state.falta_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Falta);